import React, { useState } from "react";
import {
  Checkbox,
  Callout,
  Position,
  OverlayToaster,
  Slider,
  Switch,
  Collapse,
  Button,
  H2,
  Divider,
  HTMLSelect,
  FormGroup,
} from "@blueprintjs/core";
import { Trans, withTranslation } from "react-i18next";
import i18n from "i18next";
import { w3cwebsocket as W3CWebSocket } from "websocket";

import Title from "../Structure/logo";
import { getLoggedUserLevel } from "../auth/Signin";
import { Equipment } from "./Equipment";
import KeyData from "../Structure/KeyData";
import Parks from "./Parks";
import Counters from "./Counters";
import EquipmentDetail from "./EquipmentDetail";
import EventFlow from "./Events/EventFlow";
import { SubscribersTable } from "./PresenceTable";

import PieChart from "../Charts/PieChart";
import i18next from "i18next";
import { mefState } from "../../utils/mef";
import {
  authenticatedGetFetch,
  getBackendRoute,
} from "../../utils/AuthenticatedFetch";
import { getSetting } from "../Settings/InstallationSettings";
import Summary from "./Summary";
import { parkLookup } from "../Structure/ParkSelector";
import { cachedGroups } from "./SupervisionMenu";
import { useParams } from "react-router-dom";
import PriceCalculation from "./PriceCalculation";
import RemoteIO from "./RemoteIO/RemoteIO";

const Synthese = {
  WORKING: 0,
  OUT_OF_ORDER: 1,
  FAILURE: 2,
  DISCONNECTED: 3,
};

export function getSynthese(state) {
  if (state === undefined || state.general === undefined)
    return Synthese.DISCONNECTED;
  //should always return here cause set by backend
  if (state.general.synthese !== undefined) return state.general.synthese;
  else if (state.bo !== undefined) return state.bo.synthese;
  else if (state.ca !== undefined) return state.ca.synthese;
  else if (state.cm !== undefined) return state.cm.synthese;
  else if (state.general.connected === false) return Synthese.DISCONNECTED;
  else if (state.general.lock !== undefined) // LP300
    return state.general.lock === 0 ? Synthese.WORKING : Synthese.OUT_OF_ORDER;
  else return Synthese.DISCONNECTED;
}

const typscore = {
  E: 1,
  S: 2,
  C: 3,
  L: 4,
  K: 5,
};

function sum(cpts) {
  const ret = { ca: 0, be: 0, bs: 0, lp: 0 };
  for (const val of cpts) {
    if (!isNaN(val.ca)) ret.ca += val.ca;
    if (!isNaN(val.be)) ret.be += val.be;
    if (!isNaN(val.bs)) ret.bs += val.bs;
    if (!isNaN(val.lp)) ret.lp += val.lp;
  }
  return ret;
}

function PieStates(props) {
  const s = sum(props.cptStateEq);
  return (
    <div className="flexbox-center">
      <div className="flexbox-center">
        <div className="flexbox-center">
          <PieChart
            data={props.cptState}
            labels={[
              i18n.t("working"),
              i18n.t("out of order"),
              i18n.t("failure"),
              i18n.t("disconnected"),
            ]}
            title={i18n.t("distribution of equipment by operating status")}
            colors={["#b7de92", "#eb9791", "#f0ca9e", "#dcdee0"]}
          />
        </div>
        <div>
          <div className="flexbox-center">
            <div>
              <Callout intent="success" title={<Trans>working</Trans>}>
                <KeyData
                  className="myCard2"
                  data={props.cptState[Synthese.WORKING]}
                  details={{
                    CA:
                      props.cptStateEq[Synthese.WORKING].ca +
                      (props.cptStateEq[Synthese.WORKING].ca > 0
                        ? "/" + s.ca
                        : null),
                    E:
                      props.cptStateEq[Synthese.WORKING].be +
                      (props.cptStateEq[Synthese.WORKING].be > 0
                        ? "/" + s.be
                        : null),
                    S:
                      props.cptStateEq[Synthese.WORKING].bs +
                      (props.cptStateEq[Synthese.WORKING].bs > 0
                        ? "/" + s.bs
                        : null),
                    LP:
                      props.cptStateEq[Synthese.WORKING].lp +
                      (props.cptStateEq[Synthese.WORKING].lp > 0
                        ? "/" + s.lp
                        : null),
                  }}
                />
              </Callout>
            </div>
            <div>
              <Callout intent="warning" title={<Trans>failure</Trans>}>
                <KeyData
                  className="myCard2"
                  data={props.cptState[Synthese.FAILURE]}
                  details={{
                    CA:
                      props.cptStateEq[Synthese.FAILURE].ca +
                      (props.cptStateEq[Synthese.FAILURE].ca > 0
                        ? "/" + s.ca
                        : null),
                    E:
                      props.cptStateEq[Synthese.FAILURE].be +
                      (props.cptStateEq[Synthese.FAILURE].be > 0
                        ? "/" + s.be
                        : null),
                    S:
                      props.cptStateEq[Synthese.FAILURE].bs +
                      (props.cptStateEq[Synthese.FAILURE].bs > 0
                        ? "/" + s.bs
                        : null),
                    LP:
                      props.cptStateEq[Synthese.FAILURE].lp +
                      (props.cptStateEq[Synthese.FAILURE].lp > 0
                        ? "/" + s.lp
                        : null),
                  }}
                />
              </Callout>
            </div>
            <div>
              <Callout intent="danger" title={<Trans>out of order</Trans>}>
                <KeyData
                  className="myCard2"
                  data={props.cptState[Synthese.OUT_OF_ORDER]}
                  details={{
                    CA:
                      props.cptStateEq[Synthese.OUT_OF_ORDER].ca +
                      (props.cptStateEq[Synthese.OUT_OF_ORDER].ca > 0
                        ? "/" + s.ca
                        : null),
                    E:
                      props.cptStateEq[Synthese.OUT_OF_ORDER].be +
                      (props.cptStateEq[Synthese.OUT_OF_ORDER].be > 0
                        ? "/" + s.be
                        : null),
                    S:
                      props.cptStateEq[Synthese.OUT_OF_ORDER].bs +
                      (props.cptStateEq[Synthese.OUT_OF_ORDER].bs > 0
                        ? "/" + s.bs
                        : null),
                    LP:
                      props.cptStateEq[Synthese.OUT_OF_ORDER].lp +
                      (props.cptStateEq[Synthese.OUT_OF_ORDER].lp > 0
                        ? "/" + s.lp
                        : null),
                  }}
                />
              </Callout>
            </div>
            <div>
              <Callout icon="offline" title={<Trans>disconnected</Trans>}>
                <KeyData
                  className="myCard2"
                  data={props.cptState[Synthese.DISCONNECTED]}
                  details={{
                    CA:
                      props.cptStateEq[Synthese.DISCONNECTED].ca +
                      (props.cptStateEq[Synthese.DISCONNECTED].ca > 0
                        ? "/" + s.ca
                        : null),
                    E:
                      props.cptStateEq[Synthese.DISCONNECTED].be +
                      (props.cptStateEq[Synthese.DISCONNECTED].be > 0
                        ? "/" + s.be
                        : null),
                    S:
                      props.cptStateEq[Synthese.DISCONNECTED].bs +
                      (props.cptStateEq[Synthese.DISCONNECTED].bs > 0
                        ? "/" + s.bs
                        : null),
                    LP:
                      props.cptStateEq[Synthese.DISCONNECTED].lp +
                      (props.cptStateEq[Synthese.DISCONNECTED].lp > 0
                        ? "/" + s.lp
                        : null),
                  }}
                />
              </Callout>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Equipments(props) {
  const ret = [];
  var lastKey = "init";
  var lastType;
  var sortedKeys = Object.keys(props.states);

  if (props.orderBy === "typ")
    // order by type/park/server/id
    sortedKeys.sort((a, b) => {
      if (props.states[a].general.type !== props.states[b].general.type)
        return (
          typscore[props.states[a].general.type] -
          typscore[props.states[b].general.type]
        );
      if (props.states[a].general.parc !== props.states[b].general.parc)
        return props.states[a].general.parc - props.states[b].general.parc;
      if (props.states[a].general.server !== props.states[b].general.server)
        return props.states[a].general.server - props.states[b].general.server;
      return props.states[a].general.id - props.states[b].general.id;
    });
  else if (props.orderBy === "park")
    // order by park/server/type/id
    sortedKeys.sort((a, b) => {
      if (props.states[a].general.parc !== props.states[b].general.parc)
        return props.states[a].general.parc - props.states[b].general.parc;
      if (props.states[a].general.server !== props.states[b].general.server)
        return props.states[a].general.server - props.states[b].general.server;
      if (props.states[a].general.type !== props.states[b].general.type)
        return (
          typscore[props.states[a].general.type] -
          typscore[props.states[b].general.type]
        );
      return props.states[a].general.id - props.states[b].general.id;
    });
  else if (props.orderBy === "state")
    // order by state/type/id
    sortedKeys.sort((a, b) => {
      if (getSynthese(props.states[a]) !== getSynthese(props.states[b]))
        return getSynthese(props.states[a]) - getSynthese(props.states[b]);
      if (props.states[a].general.type !== props.states[b].general.type)
        return (
          typscore[props.states[a].general.type] -
          typscore[props.states[b].general.type]
        );
      return props.states[a].general.id - props.states[b].general.id;
    });
  // device id
  else
    sortedKeys.sort(
      (a, b) => props.states[a].general.id - props.states[b].general.id
    );

  sortedKeys.forEach(function (key) {
    var shouldAdd = false;
    var synthese = getSynthese(props.states[key]);

    if (props.states[key]["general"] !== undefined) {
      switch (props.states[key]["general"]["type"]) {
        case "C":
          if (props.C === true) shouldAdd = true;
          break;
        case "E":
        case "S":
          if (props.BES === true) shouldAdd = true;
          break;
        case "L":
        case "l":
          if (props.LP === true) shouldAdd = true;
          break;
        case "K":
          if (props.CM === true) shouldAdd = true;
          break;
        default:
          shouldAdd = true;
      }
      if (shouldAdd) {
        shouldAdd = false;
        switch (synthese) {
          case Synthese.WORKING:
            if (props.OK === true) shouldAdd = true;
            break;
          case Synthese.OUT_OF_ORDER:
            if (props.KO === true) shouldAdd = true;
            break;
          case Synthese.FAILURE:
            if (props.DEF === true) shouldAdd = true;
            break;
          case Synthese.DISCONNECTED:
            if (props.DI === true) shouldAdd = true;
            break;
          default:
            shouldAdd = true;
        }
      }
      if (shouldAdd) {
        const nPark = props.states[key]["general"]["parc"];
        if (nPark !== undefined && props.parks[nPark] === false)
          shouldAdd = false;
      }
      if (shouldAdd) {
        //handle oder by type sections
        if (
          props.orderBy === "typ" &&
          i18n.t(props.states[key].general.type) !== lastKey
        )
          ret.push(
            <Callout
              key={lastKey}
              title={i18n.t(props.states[key].general.type)}
            />
          );
        if (props.orderBy === "typ")
          lastKey = i18n.t(props.states[key].general.type);

        //handle order by park sections
        if (
          props.orderBy === "park" &&
          props.states[key].general.server +
            "_" +
            props.states[key].general.parc !==
            lastKey
        ) {
          ret.push(
            <Callout
              key={lastKey}
              title={
                props.parkLookup[
                  props.states[key].general.server +
                    "_" +
                    props.states[key].general.parc
                ]
              }
            />
          );
          lastType = undefined;
        }

        if (props.orderBy === "park") {
          // add subdivider for device type
          if (lastType !== props.states[key]?.general?.type)
            ret.push(
              <Divider
                key={
                  props.states[key].general.server +
                  "__" +
                  props.states[key].general.parc +
                  props.states[key]?.general?.type
                }
                style={{ flexBasis: "100%" }}
              >
                <Trans>{props.states[key]?.general?.type}</Trans>
              </Divider>
            );

          lastType = props.states[key]?.general?.type;
          lastKey =
            props.states[key].general.server +
            "_" +
            props.states[key].general.parc;
        }

        // compare the ordering value with the previous to add a section separator
        if (props.orderBy === "state" && synthese !== lastKey)
          switch (synthese) {
            case Synthese.WORKING:
              ret.push(
                <Callout
                  key={lastKey}
                  intent="success"
                  title={<Trans>working</Trans>}
                />
              );
              break;
            case Synthese.OUT_OF_ORDER: // out of order
              ret.push(
                <Callout
                  key={lastKey}
                  intent="danger"
                  title={<Trans>out of order</Trans>}
                />
              );
              break;
            case Synthese.FAILURE: // default
              ret.push(
                <Callout
                  key={lastKey}
                  intent="warning"
                  title={<Trans>failure</Trans>}
                />
              );
              break;
            case Synthese.DISCONNECTED: // disconnected
            case 4: // unknown
              ret.push(
                <Callout
                  key={lastKey}
                  icon="offline"
                  title={<Trans>disconnected</Trans>}
                />
              );
              break;
            default:
              console.error(
                "error in switch getSynthese",
                getSynthese(props.states[key])
              );
              break;
          }

        if (props.orderBy === "state") lastKey = synthese;

        ret.push(
          <Equipment
            key={"eq" + key}
            id={"device" + key}
            selected={
              window.location.hash ===
              `#device${props.states[key]?.general?.id}_${props.states[key]?.general?.server}`
            }
            eq={props.states[key]}
            extended={false}
            imgScale={props.imgScale}
            displayAnimations={props.displayAnimations}
            displayImages={props.displayImages}
            ALPR_sensor={
              props.ALPR_sensors[props.states[key].alpr_sensor_front]
            }
          />
        );
      }
    }
  });
  if (ret.length === 0) {
    return (
      <Callout intent="primary">
        <p>
          <Trans>aucun équipement ne correspond à la selection</Trans>
        </p>
      </Callout>
    );
  } else {
    return <div className="flexbox-left">{ret}</div>;
  }
}

function EquipmentState(props) {
  const [display_device_filters, setdisplay_device_filters] = useState(false);
  const [seeCA, setseeCA] = useState(true);
  const [seeBES, setseeBES] = useState(true);
  const [seeLP, setseeLP] = useState(true);
  const [seeCM, setseeCM] = useState(true);
  const [seeKO, setseeKO] = useState(true);
  const [seeDEF, setseeDEF] = useState(true);
  const [seeOK, setseeOK] = useState(true);
  const [seeDI, setseeDI] = useState(true);
  const [orderBy, setorderBy] = useState("state");
  const [displayAnimations, setdisplayAnimations] = useState(true);
  const [displayImages, setdisplayImages] = useState(true);
  const [imgScale, setimgScale] = useState(0.4);
  const [seePark, setseePark] = useState({});

  // ParkSelector
  var ParkSelector = [];
  var temp_seePark = seePark;
  props.numPark.forEach((park) => {
    if (temp_seePark[park] === undefined) temp_seePark[park] = true;

    ParkSelector.push(
      <Checkbox
        key={"p" + park}
        checked={temp_seePark[park]}
        onChange={(cb) => {
          temp_seePark[park] = cb.target.checked;
          setseePark((seePark) => ({ ...seePark, ...temp_seePark[park] }));
        }}
      >
        <Trans>park</Trans> n°{park}
      </Checkbox>
    );
  });

  return (
    <Callout title={<Trans>equipments' state</Trans>}>
      <FormGroup
        label={<Trans>order by</Trans>}
        labelFor="input_ob"
        inline={true}
      >
        <HTMLSelect
          id="input_ob"
          options={[
            { value: "state", label: i18n.t("states") },
            { value: "typ", label: i18n.t("device type") },
            { value: "park", label: i18n.t("park id") },
            { value: "neq", label: i18n.t("device id") },
          ]}
          onChange={(ti) => setorderBy(ti.target.value)}
          value={orderBy}
        />
        <Button
          icon="filter"
          onClick={() => setdisplay_device_filters(!display_device_filters)}
          text={<Trans>filter display</Trans>}
        />
      </FormGroup>

      <Collapse isOpen={display_device_filters}>
        <div className="flexbox-center">
          <div>
            <Checkbox
              checked={seeBES}
              onChange={(cb) => {
                setseeBES(cb.target.checked);
              }}
            >
              <Trans>entry/exit terminal</Trans>
            </Checkbox>
            <Checkbox
              checked={seeCA}
              onChange={(cb) => {
                setseeCA(cb.target.checked);
              }}
            >
              <Trans>payment station</Trans>
            </Checkbox>
            <Checkbox
              checked={seeLP}
              onChange={(cb) => {
                setseeLP(cb.target.checked);
              }}
            >
              <Trans>LP</Trans>
            </Checkbox>
            <Checkbox
              checked={seeCM}
              onChange={(cb) => {
                setseeCM(cb.target.checked);
              }}
            >
              <Trans>CM</Trans>
            </Checkbox>
          </div>
          <div>
            <Checkbox
              checked={seeKO}
              onChange={(cb) => {
                setseeKO(cb.target.checked);
              }}
            >
              <Trans>out of order</Trans>
            </Checkbox>
            <Checkbox
              checked={seeDEF}
              onChange={(cb) => {
                setseeDEF(cb.target.checked);
              }}
            >
              <Trans>failure</Trans>
            </Checkbox>
            <Checkbox
              checked={seeOK}
              onChange={(cb) => {
                setseeOK(cb.target.checked);
              }}
            >
              <Trans>working</Trans>
            </Checkbox>
            <Checkbox
              checked={seeDI}
              onChange={(cb) => {
                setseeDI(cb.target.checked);
              }}
            >
              <Trans>disconnected</Trans>
            </Checkbox>
          </div>
          <div>{ParkSelector}</div>
          <div>
            <Switch
              checked={displayAnimations}
              label={i18n.t("display animations")}
              onChange={(cb) => setdisplayAnimations(cb.target.checked)}
            />
            <Switch
              checked={displayImages}
              label={i18n.t("display images")}
              onChange={(cb) => setdisplayImages(cb.target.checked)}
            />
          </div>
          <Slider
            disabled={!displayImages}
            vertical={true}
            stepSize={0.05}
            min={0.2}
            max={1}
            value={imgScale}
            onChange={(val) => setimgScale(val)}
          />
        </div>
      </Collapse>
      <Equipments
        states={props.rt_state}
        orderBy={orderBy}
        parkLookup={props.parkLookup}
        C={seeCA}
        BES={seeBES}
        LP={seeLP}
        CM={seeCM}
        OK={seeOK}
        DI={seeDI}
        KO={seeKO}
        DEF={seeDEF}
        parks={seePark}
        imgScale={imgScale}
        displayAnimations={displayAnimations}
        displayImages={displayImages}
        ALPR_sensors={props.ALPR_sensor}
      />
    </Callout>
  );
}

class Supervision extends React.Component {
  constructor(props) {
    super();
    this.state = {
      rt_state: {},
      cptState: [0, 0, 0, 0],
      cptStateEq: [
        { be: 0, bs: 0, ca: 0, lp: 0, cm: 0 },
        { be: 0, bs: 0, ca: 0, lp: 0, cm: 0 },
        { be: 0, bs: 0, ca: 0, lp: 0, cm: 0 },
        { be: 0, bs: 0, ca: 0, lp: 0, cm: 0 },
      ],
      seePark: {},
      errors: [],
      warnings: [],
      numPark: new Set(),
      ALPR_sensors: {},
      todisplay: [],
      groupId: props.groupId,
      group: {},
      groupFilter: props.groupId ? "?group=" + props.groupId : "",
      parkLookup: parkLookup(),
    };
    this.handleStateMessage = this.handleStateMessage.bind(this);
  }

  setToasterRef = (ref) => {
    this._toaster = ref;
  };

  async componentDidMount() {
    const groups = await cachedGroups();
    this.setState({ group: (groups || {})[this.props.groupId] || {} });
    if (getLoggedUserLevel() > 0) {
      //open and handle websocket
      this.clientSup = new W3CWebSocket(
        getBackendRoute("WS") + "/supervision/rt" + this.state.groupFilter,
        ["Bearer", localStorage.getItem("token")]
      );

      this.clientSup.onopen = () => {
        //console.log("WebSocket Client Connected");
      };
      this.clientSup.onmessage = (message) => {
        this.handleStateMessage(message);
      };

      this.clientALPR = new W3CWebSocket(
        getBackendRoute("WS") + "/supervision/alpr?images=false",
        ["Bearer", localStorage.getItem("token")]
      );
      this.clientALPR.onmessage = (message) => {
        const tmp = this.state.ALPR_sensors;
        try {
          const data = JSON.parse(message.data);
          // first message received is an array containing all sensors
          if (Array.isArray(data)) {
            for (const sensor of data) {
              tmp[sensor.definition.ip] = sensor;
              this.setState({ ALPR_sensors: tmp });
            }
          }
          //on flow sync receive data for one sensor in an object
          else {
            tmp[data.definition.ip] = data;
            this.setState({ ALPR_sensors: tmp });
          }
        } catch (e) {
          console.error(
            "Error while parsing alpr state",
            JSON.stringify(message)
          );
        }
      };
    }

    authenticatedGetFetch("/customsup", (res) => {
      this.setState({ todisplay: res });
    });
  }

  componentWillUnmount() {
    //close websockets when component unmount
    if (this.clientSup) this.clientSup.close();
    if (this.clientALPR) this.clientALPR.close();
  }

  getCounters() {
    let ret = {};
    if (this.state.counters)
      ret = this.state.group.counters.reduce(
        (a, c) => ({ ...a, [c.serverId + "_" + c.id]: c }),
        {}
      );
    if (this.state.group.mainCounter)
      ret[
        this.state.group.mainCounter.serverId +
          "_" +
          this.state.group.mainCounter.id
      ] = this.state.group.mainCounter;

    return ret;
  }

  getTable() {
    const SupFavs = [];
    let i = 0;
    for (const widget of this.state.todisplay) {
      switch (widget) {
        case 0:
          SupFavs.push(
            <PieStates
              key="Pie"
              cptState={this.state.cptState}
              cptStateEq={this.state.cptStateEq}
            />
          );
          break;
        case 1:
          SupFavs.push(
            <Summary
              key="Sum"
              errors={this.state.errors}
              warnings={this.state.warnings}
              isOpen={this.state.isOpen}
            />
          );
          break;
        case 2:
          SupFavs.push(
            <Parks key="Park" groupFilter={this.state.groupFilter} />
          );
          break;
        case 3:
          SupFavs.push(
            <Counters
              key="Count"
              counters={this.getCounters()}
              groupFilter={this.state.groupFilter}
            />
          );
          break;
        case 4:
          SupFavs.push(
            <EventFlow
              key="EF1"
              static={true}
              realTime={true}
              pageSize={20}
              group={this.state.groupId}
            />
          );
          break;
        case 5:
          SupFavs.push(
            <EventFlow
              key="EF2"
              static={false}
              realTime={false}
              enableSearch={true}
              group={this.state.groupId}
            />
          );
          break;
        case 6:
          SupFavs.push(<SubscribersTable key="Sub" />);
          break;
        case 7:
          SupFavs.push(
            <EquipmentState
              key="Eq"
              numPark={this.state.numPark}
              parkLookup={this.state.parkLookup}
              ALPR_sensor={this.state.ALPR_sensors}
              rt_state={this.state.rt_state}
            />
          );
          break;
        case 8:
          SupFavs.push(<PriceCalculation key="pc" />);
          break;
        case 9:
          SupFavs.push(
            <RemoteIO key="rio" groupFilter={this.state.groupFilter} />
          );
          break;
        default:
          break;
      }
      SupFavs.push(<br key={"section" + i++} />);
    }
    return SupFavs;
  }

  getType(state) {
    switch (state.general.type) {
      case "E":
        return "be";
      case "S":
        return "bs";

      case "l":
      case "L":
      case "p":
      case "P":
        return "lp";

      case "C":
        return "ca";
      case "K":
        return "cm";

      default:
        return "";
    }
  }

  majCptState() {
    const cpt = [0, 0, 0, 0];
    const cptEq = [
      { be: 0, bs: 0, ca: 0, lp: 0, cm: 0 },
      { be: 0, bs: 0, ca: 0, lp: 0, cm: 0 },
      { be: 0, bs: 0, ca: 0, lp: 0, cm: 0 },
      { be: 0, bs: 0, ca: 0, lp: 0, cm: 0 },
    ];

    Object.keys(this.state.rt_state).forEach((key) => {
      try {
        cpt[getSynthese(this.state.rt_state[key])]++;
        cptEq[getSynthese(this.state.rt_state[key])][
          this.getType(this.state.rt_state[key])
        ]++;
      } catch (e) {
        console.error(
          "bad state in majCptState:" + getSynthese(this.state.rt_state[key])
        );
        cpt[3]++;
        cptEq[3][this.getType(this.state.rt_state[key])]++;
      }
    });
    this.setState({ cptState: cpt, cptStateEq: cptEq });
  }

  majNotifications() {
    const errors = [];
    const warnings = [];
    var numPark = new Set();
    Object.keys(this.state.rt_state).forEach((key) => {
      const neq = this.state.rt_state[key].general.id;
      const typ = this.state.rt_state[key].general.type;
      if (this.state.rt_state[key].general.parc !== undefined)
        numPark.add(this.state.rt_state[key].general.parc);

      // CA
      if (this.state.rt_state[key].ca !== undefined) {
        if (this.state.rt_state[key].ca["Ouv_Porte"] !== 0)
          errors.push(
            <tr key={key + "2"}>
              <td>
                <EquipmentDetail equipmentId={key} text={typ + " - " + neq} />
              </td>
              <td>
                <Trans>door open</Trans>
              </td>
            </tr>
          );

        if (
          this.state.rt_state[key].ca.coin_acceptor.Manque_Monnaie !== undefined
        ) {
          switch (this.state.rt_state[key].ca.coin_acceptor.Manque_Monnaie) {
            case 1: // VIDE,
              errors.push(
                <tr key={key + "3"}>
                  <td>
                    <EquipmentDetail
                      equipmentId={key}
                      text={typ + " - " + neq}
                    />
                  </td>
                  <td>{i18n.t("monnayeur vide")}</td>
                </tr>
              );
              break;
            case 2: // PRESQUE_VIDE,
              warnings.push(
                <tr key={key + "4"}>
                  <td>
                    <EquipmentDetail
                      equipmentId={key}
                      text={typ + " - " + neq}
                    />
                  </td>
                  <td>{i18n.t("monnayeur presque vide")}</td>
                </tr>
              );
              break;
            case 4: // PRESQUE_PLEIN
              warnings.push(
                <tr key={key + "5"}>
                  <td>
                    <EquipmentDetail
                      equipmentId={key}
                      text={typ + " - " + neq}
                    />
                  </td>
                  <td>{i18n.t("monnayeur presque plein")}</td>
                </tr>
              );
              break;
            case 0: // PLEIN,
            case 3: // NORMAL,
            default:
              //errors.push(<p>{neq + ": monnayeur plein"}</p>)
              break;
          }
        }
        if (this.state.rt_state[key].ca["cttm"] !== undefined)
          if (
            this.state.rt_state[key].ca["cttm"]["Fin_Tk1"] === 1 &&
            this.state.rt_state[key].ca["cttm"]["Fin_Tk2"] === 1
          )
            errors.push(
              <tr key={key + "6"}>
                <td>
                  <EquipmentDetail equipmentId={key} text={typ + " - " + neq} />
                </td>
                <td>{i18n.t("no more ticket in reserve")}</td>
              </tr>
            );
          else if (
            this.state.rt_state[key].ca["cttm"]["Fin_Tk1"] === 1 ||
            this.state.rt_state[key].ca["cttm"]["Fin_Tk2"] === 1
          )
            warnings.push(
              <tr key={key + "7"}>
                <td>
                  <EquipmentDetail equipmentId={key} text={typ + " - " + neq} />
                </td>
                <td>{i18n.t("one of the two ticket reserves is empty")}</td>
              </tr>
            );

        if (this.state.rt_state[key].ca.Intervention === 1)
          warnings.push(
            <tr key={key + "8"}>
              <td>
                <EquipmentDetail equipmentId={key} text={typ + " - " + neq} />
              </td>
              <td>
                <Trans>intervention in progress by user</Trans> n°
                {this.state.rt_state[key].ca.Code_Util}
              </td>
            </tr>
          );
      }

      // BES
      if (this.state.rt_state[key].bo !== undefined) {
        if (this.state.rt_state[key].bo["Effr_Basse"] !== 0)
          errors.push(
            <tr key={key + "9"}>
              <td>
                <EquipmentDetail equipmentId={key} text={typ + " - " + neq} />
              </td>
              <td>{i18n.t("door open")}</td>
            </tr>
          );

        if (this.state.rt_state[key].bo["cttm"] !== undefined)
          if (
            this.state.rt_state[key].bo["cttm"]["Fin_Tk1"] === 1 &&
            this.state.rt_state[key].bo["cttm"]["Fin_Tk2"] === 1
          )
            errors.push(
              <tr key={key + "10"}>
                <td>
                  <EquipmentDetail equipmentId={key} text={typ + " - " + neq} />
                </td>
                <td>{i18n.t("no more ticket in reserve")}</td>
              </tr>
            );
          else if (
            this.state.rt_state[key].bo["cttm"]["Fin_Tk1"] === 1 ||
            this.state.rt_state[key].bo["cttm"]["Fin_Tk2"] === 1
          )
            warnings.push(
              <tr key={key + "11"}>
                <td>
                  <EquipmentDetail equipmentId={key} text={typ + " - " + neq} />
                </td>
                <td>{i18n.t("one of the two ticket reserves is empty")}</td>
              </tr>
            );
      }

      // CM
      if (this.state.rt_state[key].cm !== undefined) {
        if (this.state.rt_state[key].cm["cttm"] !== undefined)
          if (
            this.state.rt_state[key].cm["cttm"]["Fin_Tk1"] === 1 &&
            this.state.rt_state[key].cm["cttm"]["Fin_Tk2"] === 1
          )
            errors.push(
              <tr key={key + "13"}>
                <td>
                  <EquipmentDetail equipmentId={key} text={typ + " - " + neq} />
                </td>
                <td>{i18n.t("no more ticket in reserve")}</td>
              </tr>
            );
      }
    });
    this.setState({ errors: errors, warnings: warnings, numPark: numPark });
  }

  parseEqState(parsedmsg, solo) {
    try {
      if (parsedmsg["general"]["server"] === undefined) {
        console.error("RECEIVE STATE WITHOUT SERVER", parsedmsg);
        return;
      }
      const neq = parsedmsg.general.id;
      parsedmsg["last_update"] = new Date().toLocaleTimeString(
        i18next.language
      );

      const firststate =
        this.state.rt_state[neq + "_" + parsedmsg["general"]["server"]] ===
        undefined;
      const oldstate = getSynthese(
        this.state.rt_state[neq + "_" + parsedmsg["general"]["server"]]
      );
      const newstate = getSynthese(parsedmsg);

      var newState = Object.assign({}, this.state); // Clone the state obj in newState
      newState.rt_state[neq + "_" + parsedmsg["general"]["server"]] = parsedmsg; // modify newState

      if (this.state.rt_state[neq + "_" + parsedmsg["general"]["server"]]) {
        if (solo && !firststate && newstate !== oldstate) {
          // else first state = no alert
          if (getSetting("display alert on device state change", true)) {
            var intent = "normal";
            switch (newstate) {
              case 0:
                intent = "success";
                break;
              case 1:
                intent = "danger";
                break;
              case 2:
                intent = "warning";
                break;
              default:
                intent = ""; // = grey
            }
            this._toaster.show({
              intent: intent,
              message: (
                <p>
                  <Trans>device</Trans>{" "}
                  <EquipmentDetail
                    key={"toast" + parsedmsg["last_update"]}
                    equipmentId={parsedmsg.general.id}
                    text={parsedmsg.general.lbl}
                  />{" "}
                  <Trans>is now in state</Trans> {mefState(newstate)} (
                  <Trans>was</Trans> {mefState(oldstate)} )
                </p>
              ),
            });
          }
        }
      }
    } catch (e) {
      console.error("cannot parse device state", parsedmsg, e);
    }
  }

  handleStateMessage(message) {
    try {
      if (message.data instanceof Blob) return;
      const parsedmsg = JSON.parse(message.data);
      //single state
      if (
        parsedmsg.general !== undefined &&
        parsedmsg.general.id !== undefined
      ) {
        this.parseEqState(parsedmsg, true);
        this.majCptState();
        this.majNotifications();
      } else {
        //multiple states at init
        var itemsProcessed = 0;
        Object.keys(parsedmsg).forEach((key) => {
          if (
            parsedmsg[key].general !== undefined &&
            parsedmsg[key].general.id !== undefined
          ) {
            this.parseEqState(parsedmsg[key], false);
          }
          if (++itemsProcessed === Object.keys(parsedmsg).length) {
            this.majCptState();
            this.majNotifications();
          }
        });
      }
    } catch (e) {
      console.error("cannot parse state message" + message.data, e);
    }
  }

  render() {
    return (
      <div className="component-body">
        <OverlayToaster
          ref={this.setToasterRef}
          position={Position.BOTTOM_LEFT}
          maxToasts={3}
        />
        <div>
          <Title icon="drive-time" text="Supervision" />
          <H2>{this.state?.group?.label}</H2>
          {this.getTable()}
        </div>
      </div>
    );
  }
}

export function SupHandler(props) {
  const { groupId } = useParams();
  return <Supervision {...props} key={groupId} groupId={groupId} />;
}

export default withTranslation()(SupHandler);
